/* eslint-disable */
export default {
  schedule: 'Programma riunione',
  prompt:
    'Autorizza RingCentral ad accedere alle informazioni sul tuo account.',
  saveAsDefault: 'Salva come predefinito',
  launchMeeting: 'Avvia riunione',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
